import { render, staticRenderFns } from "./HistoryViewPage.vue?vue&type=template&id=3dc7f879&scoped=true&"
import script from "./HistoryViewPage.vue?vue&type=script&lang=js&"
export * from "./HistoryViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7f879",
  null
  
)

export default component.exports